import { Breadcrumbs } from "../../../AbstractElements";
import { Popover, UiKits } from "../../../Constant";
import { Container, Row } from "reactstrap";
import BasicPopover from "./BasicPopover";
import PopoverDirection from "./PopoverDirection";
import PopoverOffset from "./PopoverOffset";

const PopoverContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Popover} parent={UiKits} title={Popover} />
      <Container fluid>
        <Row>
          <BasicPopover />
          <PopoverDirection />
          <PopoverOffset />
        </Row>
      </Container>
    </>
  );
};

export default PopoverContainer;
